module.exports = __webpack_public_path__ + "static/media/landing-page-icon.b9d0ad63.svg";